import { Helmet } from "react-helmet-async";
import { SITE_URL, buildCanonical } from "@/lib/seo";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Common SEO head element used by every page.
// props: title, description, path (optional, falls back to current pathname),
//        image (optional), schema (JSON-LD object or array), noindex (bool)
export default function SEO({
  title,
  description,
  path,
  image = `${SITE_URL}/og.jpg`,
  schema,
  noindex = false,
}) {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const canonical = buildCanonical(path || pathname);
  const schemas = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Ragi" />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={i18n.language} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}
